import { Link } from "react-router-dom";
import { MapPin, Users, BedDouble, Bath } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/lib/LanguageContext";

export default function ListingCard({ listing, index = 0 }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const { t } = useLanguage();

  return (
    <Link
      to={`/unterkunft/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block animate-fade-in-up"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="card-hover rounded-3xl overflow-hidden bg-white border border-black/5">
        <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F7]">
          {!imgLoaded && <div className="absolute inset-0 img-skeleton" />}
          <img
            src={listing.thumbnailUrl || listing.images?.[0]}
            alt={listing.name}
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            className={`w-full h-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:scale-105 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
          />
          <div className="absolute bottom-4 left-4 crystal-glass rounded-full px-4 py-2">
            <span className="text-sm font-semibold text-[#1D1D1F]">
              {t("card_from")} {listing.price} EUR {t("card_per_night")}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-semibold text-[#1D1D1F] tracking-tight line-clamp-1 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {listing.name}
          </h3>
          <div className="flex items-center gap-1.5 text-[#86868B] text-sm mb-3">
            <MapPin className="w-3.5 h-3.5" />
            <span>{listing.city}, {listing.country}</span>
          </div>
          <div className="flex items-center gap-4 text-[#86868B] text-sm">
            <div className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" /><span>{listing.personCapacity}</span></div>
            <div className="flex items-center gap-1.5"><BedDouble className="w-3.5 h-3.5" /><span>{listing.bedroomsNumber}</span></div>
            <div className="flex items-center gap-1.5"><Bath className="w-3.5 h-3.5" /><span>{listing.bathroomsNumber}</span></div>
          </div>
        </div>
      </div>
    </Link>
  );
}
